import Vue from "vue";
import Router from "vue-router";
import findLast from "lodash/findLast";
import {notification} from "ant-design-vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {check, isLogin} from "./utils/auth";

Vue.use(Router);

let authority = ["root", "超级管理员", "项目管理员"]
const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [

        {
            path: "/user",
            hideInMenu: true,
            component: () =>
                import(/* webpackChunkName: "layout" */ "./layouts/UserLayout"),
            children: [
                {
                    path: "/user",
                    redirect: "/user/login"
                },
                {
                    path: "/user/login",
                    name: "login",
                    component: () =>
                        import(/* webpackChunkName: "user" */ "./views/User/Login")
                },
                {
                    path: "/user/register",
                    name: "register",
                    component: () =>
                        import(/* webpackChunkName: "user" */ "./views/User/Register")
                },
                {
                    path: "/user/register-result",
                    name: "register.result",
                    component: () =>
                        import(/* webpackChunkName: "user" */ "./views/User/RegisterResult")
                }
            ]
        },
        {
            path: "/",
            meta: {authority: authority},
            component: () => import("./layouts/BasicLayout"),
            children: [
                {
                    path: "/",
                    meta: {title: "项目管理", authority: authority},
                    redirect: "/project/all"
                },
                {
                    path: "/project",
                    name: "project",
                    component: {render: h => h("router-view")},
                    meta: {icon: "form", title: "项目管理"},
                    children: [
                        {
                            meta: {title: "项目列表", authority: authority},
                            path: "/project/all",
                            name: "project_all",
                            component: () => import("./views/project/All")
                        },
                        {
                            meta: {title: "创建项目", authority: authority},
                            path: "/project/add",
                            hideInMenu: true,
                            name: "project_add",
                            component: () => import("./views/project/Add")
                        },
                        {
                            meta: {icon: "form", title: "编辑项目信息", authority: authority},
                            path: "/project/edit",
                            hideInMenu: true,
                            name: "project_edit",
                            component: () => import("./views/project/Edit")
                        },
                        {
                            meta: {icon: "form", title: "项目历史版本", authority: authority},
                            path: "/project/versions",
                            hideInMenu: true,
                            name: "project_versions",
                            component: () => import("./views/project/Versions")
                        },
                        {
                            meta: {icon: "form", title: "详情", authority: authority},
                            path: "/project/detail",
                            hideInMenu: true,
                            name: "project_detail",
                            component: () => import("./views/project/Detail")
                        },
                        {
                            meta: {icon: "form", title: "项目医生", authority: authority},
                            path: "/project/all/doctor",
                            hideInMenu: true,
                            name: "project_all_doctor",
                            component: () => import("./views/project/AllDoctor")
                        },
                        {
                            meta: {icon: "form", title: "添加医生", authority: authority},
                            path: "/project/add/doctor",
                            hideInMenu: true,
                            name: "project_add_doctor",
                            component: () => import("./views/project/AddDoctor")
                        },
                        {
                            meta: {icon: "form", title: "参与人员", authority: authority},
                            path: "/project/people/list",
                            hideInMenu: true,
                            name: "project_people_list",
                            component: () => import("./views/project/PeopleList")
                        },
                        {
                            meta: {icon: "form", title: "签署的知情书详情", authority: authority},
                            path: "/project/book",
                            hideInMenu: true,
                            name: "project_book",
                            component: () => import("./views/project/Book")
                        },
                    ]
                },
                {
                    path: "/user/manager",
                    name: "user_manager",
                    meta: {icon: "form", title: "用户管理", authority: authority},
                    component: {render: h => h("router-view")},
                    children: [
                        {
                            path: "/user/manager/all",
                            name: "user_manager_all",
                            meta: {title: "用户列表", authority: authority},
                            component: () => import("./views/User/All")
                        },
                        {
                            meta: {title: "创建管理用户", authority: authority},
                            path: "/user/manager/add",
                            hideInMenu: true,
                            name: "user_manager_add",
                            component: () => import("./views/User/Add")
                        },{
                            meta: {title: "用户编辑", authority: authority},
                            path: "/user/manager/edit",
                            name: "user_manager_edit",
                            hideInMenu: true,
                            component: () => import("./views/User/Edit")
                        },
                        {
                            path: "/user/manager/all_real_name",
                            name: "user_manager_all_real_name",
                            meta: {title: "实名审核", authority: authority},
                            component: () => import("./views/User/AllRealName")
                        },
                        {
                            path: "/user/manager/real_name_detail",
                            name: "user_manager_real_name_detail",
                            hideInMenu: true,
                            meta: {title: "实名审核", authority: authority},
                            component: () => import("./views/User/RealNameDetail")
                        }

                    ]
                },
                {
                    path: "/doctor",
                    name: "doctor",
                    meta: {icon: "form", title: "医生管理", authority: authority},
                    component: {render: h => h("router-view")},
                    children: [
                        {
                            path: "/doctor/all",
                            name: "doctor_all",
                            meta: {title: "医生列表", authority: authority},
                            component: () => import("./views/doctor/All")
                        },
                        {
                            meta: {title: "创建医生", authority: authority},
                            path: "/doctor/add",
                            name: "doctor_add",
                            hideInMenu: true,
                            component: () => import("./views/doctor/Add")
                        },
                        {
                            meta: {icon: "form", title: "编辑医生信息", authority: authority},
                            path: "/doctor/edit",
                            hideInMenu: true,
                            name: "doctor_manager_edit",
                            component: () => import("./views/doctor/Edit")
                        },
                    ]
                },
                // {
                //     path: "/assistant",
                //     name: "assistant",
                //     meta: {icon: "form", title: "研究者助理管理", authority: authority},
                //     component: {render: h => h("router-view")},
                //     children: [
                //         {
                //             path: "/assistant/all",
                //             name: "assistant_all",
                //             meta: {title: "研究者助理列表", authority: authority},
                //             component: () => import("./views/assistant/All")
                //         },
                //         {
                //             meta: {title: "创建研究者助理", authority: authority},
                //             path: "/assistant/add",
                //             name: "assistant_add",
                //             component: () => import("./views/assistant/Add")
                //         },
                //         {
                //             meta: {icon: "form", title: "编辑研究者助理信息", authority: authority},
                //             path: "/assistant/edit",
                //             hideInMenu: true,
                //             name: "assistant_edit",
                //             component: () => import("./views/assistant/Edit")
                //         },
                //     ]
                // },
                {
                    path: "/unit",
                    name: "unit",
                    meta: {icon: "form", title: "单位管理", authority: authority},
                    component: {render: h => h("router-view")},
                    children: [
                        {
                            meta: {title: "单位列表", authority: authority},
                            path: "/unit/all",
                            name: "unite_all",
                            component: () => import("./views/Unit/All")
                        },
                        {
                            meta: {title: "创建单位", authority: authority},
                            path: "/unit/add",
                            hideInMenu: true,
                            name: "unit_add",
                            component: () => import("./views/Unit/Add")
                        },
                    ]
                },
                // {
                //     path: "/notice",
                //     name: "notice",
                //     meta: {icon: "form", title: "通知管理", authority: authority},
                //     component: {render: h => h("router-view")},
                //     children: [
                //         {
                //             meta: {title: "所有未读通知", authority: authority},
                //             path: "/notice/all",
                //             name: "notice_all",
                //             component: () => import("./views/notice/All")
                //         },
                //         {
                //             meta: {title: "创建通知", authority: authority},
                //             path: "/notice/add",
                //             name: "notice_add",
                //             component: () => import("./views/notice/Add")
                //         },
                //     ]
                // },
                // {
                //     path: "/ce",
                //     name: "ce",
                //     meta: {icon: "form", title: "临床实验", authority: authority},
                //     component: {render: h => h("router-view")},
                //     children: [
                //         {
                //             meta: {title: "列表", authority: authority},
                //             path: "/ce/all",
                //             name: "ce_all",
                //             component: () => import("./views/CE/All")
                //         },
                //         {
                //             meta: {title: "上传", authority: authority},
                //             path: "/ce/add",
                //             name: "ce_add",
                //             component: () => import("./views/CE/Add")
                //         },
                //         {
                //             meta: {icon: "form", title: "编辑", authority: authority},
                //             path: "/ce/edit",
                //             hideInMenu: true,
                //             name: "ce_edit",
                //             component: () => import("./views/CE/Edit")
                //         },


                //     ]
                // },

            ]
        },
        {
            path: "/403",
            name: "403",
            hideInMenu: true,
            component: () =>
                import(/* webpackChunkName: "exception" */ "@/views/Exception/403")
        },
        {
            path: "*",
            name: "404",
            hideInMenu: true,
            component: () =>
                import(/* webpackChunkName: "exception" */ "@/views/Exception/404")
        }

        // {
        //   path: "/dashboard",
        //   meta: { authority: ["user", "admin"] },
        //   component: () =>
        //     import(/* webpackChunkName: "layout" */ "./layouts/BasicLayout"),
        //   children: [
        //     // dashboard
        //     {
        //       path: "/",
        //       redirect: "/dashboard/analysis"
        //     },
        //     {
        //       path: "/dashboard",
        //       name: "dashboard",
        //       meta: { icon: "dashboard", title: "仪表盘" },
        //       component: { render: h => h("router-view") },
        //       children: [
        //         {
        //           path: "/dashboard/analysis",
        //           name: "analysis",
        //           meta: { title: "分析页" },
        //           component: () =>
        //             import(/* webpackChunkName: "dashboard" */ "./views/Dashboard/Analysis")
        //         }
        //       ]
        //     },
        //     // form
        //     {
        //       path: "/form",
        //       name: "form",
        //       component: { render: h => h("router-view") },
        //       meta: { icon: "form", title: "表单", authority: ["admin"] },
        //       children: [
        //         {
        //           path: "/form/basic-form",
        //           name: "basicform",
        //           meta: { title: "基础表单" },
        //           component: () =>
        //             import(/* webpackChunkName: "form" */ "./views/Forms/BasicForm")
        //         },
        //         {
        //           path: "/form/step-form",
        //           name: "stepform",
        //           hideChildrenInMenu: true,
        //           meta: { title: "分布表单" },
        //           component: () =>
        //             import(/* webpackChunkName: "form" */ "./views/Forms/StepForm"),
        //           children: [
        //             {
        //               path: "/form/step-form",
        //               redirect: "/form/step-form/info"
        //             },
        //             {
        //               path: "/form/step-form/info",
        //               name: "info",
        //               component: () =>
        //                 import(/* webpackChunkName: "form" */ "./views/Forms/StepForm/Step1")
        //             },
        //             {
        //               path: "/form/step-form/confirm",
        //               name: "confirm",
        //               component: () =>
        //                 import(/* webpackChunkName: "form" */ "./views/Forms/StepForm/Step2")
        //             },
        //             {
        //               path: "/form/step-form/result",
        //               name: "result",
        //               component: () =>
        //                 import(/* webpackChunkName: "form" */ "./views/Forms/StepForm/Step3")
        //             }
        //           ]
        //         }
        //       ]
        //     },
        //     // Exception
        //     {
        //       path: "/exception",
        //       name: "exception",
        //       component: { render: h => h("router-view") },
        //       redirect: "/exception/403",
        //       meta: { title: "异常页", icon: "warning", authority: ["admin"] },
        //       children: [
        //         {
        //           path: "/exception/403",
        //           name: "exception403",
        //           component: () =>
        //             import(/* webpackChunkName: "exception" */ "@/views/Exception/403"),
        //           meta: { title: "403" }
        //         },
        //         {
        //           path: "/exception/404",
        //           name: "exception404",
        //           component: () =>
        //             import(/* webpackChunkName: "exception" */ "@/views/Exception/404"),
        //           meta: { title: "404" }
        //         },
        //         {
        //           path: "/exception/500",
        //           name: "exception500",
        //           component: () =>
        //             import(/* webpackChunkName: "exception" */ "@/views/Exception/500"),
        //           meta: { title: "500" }
        //         }
        //       ]
        //     },
        //     // Profile
        //     {
        //       path: "/profile",
        //       name: "profile",
        //       component: { render: h => h("router-view") },
        //       redirect: "/profile/basic",
        //       meta: { title: "详情页", icon: "profile", authority: ["admin"] },
        //       children: [
        //         {
        //           path: "/profile/basic",
        //           name: "basic",
        //           component: () =>
        //             import(/* webpackChunkName: "profile" */ "@/views/Profile/BasicProfile"),
        //           meta: { title: "基础详情页" }
        //         },
        //         {
        //           path: "/profile/advanced",
        //           name: "advanced",
        //           component: () =>
        //             import(/* webpackChunkName: "profile" */ "@/views/Profile/AdvancedProfile"),
        //           meta: { title: "高级详情页" }
        //         }
        //       ]
        //     }
        //   ]
        // },

    ]
});

router.beforeEach((to, from, next) => {
    // console.log("路由开始", to.path, from.path)
    // if (to.path !== from.path) {
    //   NProgress.start();
    // }
    const record = findLast(to.matched, record => record.meta.authority);
    // console.log("record", record)
    if (record && !check(record.meta.authority)) {
        if (!isLogin() && to.path !== "/user/login") {
            next({
                path: "/user/login"
            });
        } else if (to.path !== "/403") {
            notification.error({
                message: "403",
                description: "你没有权限访问，请联系管理员咨询。"
            });
            next({
                path: "/403"
            });
        }
        NProgress.done();
    }

    next();
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
